export default class UrlBuilder {
    constructor() {
        this.state = {}
        let obj
        if (arguments.length == 1 && typeof (arguments[0]) == 'object') {
            obj = arguments[0]
        } else if (arguments.length == 2) {
            obj = arguments[1]
        }
        if (arguments.length > 0 && typeof (arguments[0]) == 'string') {
            this._url = arguments[0]
        } else {
            this._url = window.location.origin + window.location.pathname
        }
        if (obj !== undefined)
            this.merge(obj);
    }

    merge(obj) {
        var s = this.state;
        Object.keys(obj).forEach(function (key) {
            var val = obj[key]
            if (val === null || val === '' || val === undefined || (Array.isArray(val) && val.length == 0))
                return;
            if (Array.isArray(val))
                val = val.map(v => encodeURIComponent(v)).join(',')
            else
                val = encodeURIComponent(val)
            s[key] = val
        });
    }

    getUrl() {
        var s = this.state;
        let url = this._url;
        let query = Object.keys(this.state).map(function (key) {
            return key + '=' + s[key];
        }).join('&');
        return query != '' ? url + '?' + query : url;
    }

    pushHistory() {
        history.pushState(null, '', this.getUrl());
    }

    replaceHistory() {
        history.replaceState(null, '', this.getUrl());
    }

    navigate() {
        location.href = this.getUrl()
    }

}